import React from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import NaytaPaluuNappi from "./NaytaPaluuNappi";

import plussa from "./img/Plus.png";
import miinus from "./img/Miinus.png";
import tuotteet from "./json/tuotteet tuotantoon";

const NaytaKori = (props) => {
  const { tila, asetatila } = props;

  const { tuoteId } = useParams();
  let muutos = tuoteId === undefined ? 0 : 1;
  const navigate = useNavigate();

  function handleClick(event) {
    const kori = tila.kori;
    const tid = event.target.id;
    let klik = event.target.name;
    document.documentElement.style.setProperty("--koriAnimaatio", "none");
    if (klik === "maksutapa") navigate("/maksutapa");
    else {
      muutos = (klik === "plus") - (klik === "miinus");
      let lkm = kori.get("lkm") + muutos;
      if (muutos) asetatila("kori", { tid, muutos });
      if (klik === "tyhjennä") {
        asetatila("kori", { 0: 0 });
        lkm = 0;
      }
      if (!lkm) navigate("/");
    }
  }

  const hinnat = [];
  const summa = [];
  let yhteensä = 0;
  const rock = [];
  tila.kori.forEach((lkm, tid) => {
    if (!isNaN(tid)) {
      const tuote = tuotteet.filter((t) => t.Ttunnus === tid)[0];
      hinnat[tid] = tuote.Hinta.replace(",", ".");
      const hinta = parseFloat(hinnat[tid]);
      const sum = lkm * hinta;
      const summ = sum.toFixed(2);
      summa[tid] = lkm * hinnat[tid];
      yhteensä += summa[tid];
      rock[tid] = (
        <tr>
          <td>
            <Link to={"/tuote/" + tuote.Ttunnus}>{tuote.Tuote}</Link>
          </td>
          <td>
            <button onClick={handleClick} className="pikkunappi">
              <img
                src={plussa}
                id={tid}
                name="plus"
                alt="Lisää lukumäärää korissa"
                title="Lisää lukumäärää korissa"
                className="pikkunappi"
              />
            </button>
            <button onClick={handleClick} className="pikkunappi2">
              <img
                src={miinus}
                id={tid}
                name="miinus"
                alt="Vähennä lukumäärää korissa"
                title="Vähennä lukumäärää korissa"
                className="pikkunappi"
              />
            </button>
          </td>
          <td>{lkm}</td>
          <td>{tuote.Hinta}€</td>
          <td>{summ}€</td>
        </tr>
      );
    }
  });
  const yht = yhteensä.toFixed(2);
  return (
    <div>
      <h3>Korin sisältö:</h3>
      <table className="kori">
        <thead>
          <th>Tuote</th>
          <th colSpan="2">Lkm</th>
          <th>Hinta</th>
          <th>Yhteensä</th>
          <th></th>
        </thead>
        <tbody>
          {rock}
          <tr>
            <td colSpan="3">
              <b>Kori yhteensä:</b>
            </td>
            <td>
              <b>{yht}€</b>
            </td>
          </tr>
        </tbody>
      </table>
      <button
        className="nappi nappi3"
        type="button"
        name="tyhjennä"
        onClick={handleClick}
        title="Tyhjennä kori"
      >
        Tyhjennä
      </button>
      <button
        className="nappi"
        type="button"
        name="maksutapa"
        onClick={handleClick}
        title="Jatka lähettämään tilaus"
      >
        Tilaa
      </button>
      <NaytaPaluuNappi />
    </div>
  );
};

export default NaytaKori;
